import { ReactElement } from 'react';
import { useZodFormFieldSingleValue } from '~/components/zod/ZodForm';
import { VOICE_OPTS } from '~/tenants/bre/performable/common';
import { BreSocialRate } from '~/tenants/bre/performable/social/BreSocialData';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { TenantPackageAddOnCards, TenantPackageAddOnCheckboxName } from '~/tenants/common/package';

export default function BreSocialAddOns({ persona }: { persona: PersonaType }): ReactElement {
  const narration = useZodFormFieldSingleValue('narration', (v) => v === 'true');

  return (
    <>
      <TenantPackageAddOnCheckboxName
        name="intro"
        title="Agent Intro"
        description="Add agent on camera intro."
        image="tenant/bre/social/intro.jpg"
        persona={persona}
        cost={BreSocialRate.INTRO}
      />
      <TenantPackageAddOnCheckboxName
        name="narration"
        title="Agent Voice-Over"
        description="Add agent narration."
        image="tenant/bre/social/narration.jpg"
        persona={persona}
        cost={BreSocialRate.NARRATION}
      />
      <TenantPackageAddOnCards
        name="voiceover"
        title="Professional Voice-Over"
        description="Enhance your video with a professional voice-over and script."
        image="tenant/bre/social/kwasi.png"
        persona={persona}
        options={VOICE_OPTS}
        cost={BreSocialRate.VOICEOVER}
        cols={2}
        required
      />
    </>
  );
}
